module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.match_live && _vm.match_live.length) ? [_c('nav', [_vm._v(_vm._s(_vm.$t('broadcast')))]), _vm._v(" "), _c('article', {
    staticClass: "con"
  }, [_c('div', {
    staticClass: "channel-wrap"
  }, _vm._l((_vm.match_live), function(item) {
    return _c('span', {
      key: item,
      staticClass: "channel"
    }, [_vm._v(_vm._s(item))])
  }))])] : _vm._e(), _vm._v(" "), _c('nav', [_vm._v(_vm._s(_vm.$t('past_games')))]), _vm._v(" "), (_vm.battle_history) ? _c('article', {
    staticClass: "con"
  }, [(_vm.battle_history['list'] && _vm.battle_history['list'].length) ? [_c('div', {
    staticClass: "box"
  }, [_c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "home"
  }, [_vm._v(_vm._s(_vm.team_A))]), _vm._v(" "), _c('td', {
    staticClass: "mid"
  }, [_vm._v(_vm._s(_vm.$t('pg_lng', {
    count: _vm.battle_history.list.length
  })))]), _vm._v(" "), _c('td', {
    staticClass: "away"
  }, [_vm._v(_vm._s(_vm.team_B))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "bar"
  }, [_c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "win",
    style: ({
      width: _vm.battle_history['percent']['win'] + '%'
    })
  }, [_vm._v(_vm._s(_vm.$tc('pg_w', 10, {
    count: _vm.battle_history['team_A']['win']
  })) + "\n                        ")]), _vm._v(" "), _c('td', {
    staticClass: "draw",
    style: ({
      width: _vm.battle_history['percent']['draw'] + '%'
    })
  }, [_vm._v(_vm._s(_vm.$tc('pg_d',
    10, {
      count: _vm.battle_history['team_A']['draw']
    })) + "\n                        ")]), _vm._v(" "), _c('td', {
    staticClass: "lose",
    style: ({
      width: _vm.battle_history['percent']['lose'] + '%'
    })
  }, [_vm._v(_vm._s(_vm.$tc('pg_w',
    10, {
      count: _vm.battle_history['team_B']['win']
    })) + "\n                        ")])])])])]), _vm._v(" "), _c('table', {
    staticClass: "list_1"
  }, [_c('tbody', [_c('tr', [_c('th', {
    staticClass: "date"
  }, [_vm._v(_vm._s(_vm.$t('pg_date')))]), _vm._v(" "), _c('th', {
    staticClass: "cup"
  }, [_vm._v(_vm._s(_vm.$t('pg_competition')))]), _vm._v(" "), _c('th', {
    staticClass: "home"
  }, [_vm._v(_vm._s(_vm.$t('pg_home')))]), _vm._v(" "), _c('th', {
    staticClass: "stat"
  }, [_vm._v(_vm._s(_vm.$t('pg_result')))]), _vm._v(" "), _c('th', {
    staticClass: "away"
  }, [_vm._v(_vm._s(_vm.$t('pg_away')))])]), _vm._v(" "), _vm._l((_vm.battle_history.list), function(match, num) {
    return _c('tr', {
      key: match.match_href,
      class: match['color']
    }, [_c('td', {
      staticClass: "time"
    }, [_c('p', [_vm._v(_vm._s(match['date']))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(match['year']))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(match['competition']))]), _vm._v(" "), _c('td', {
      class: {
        team: match['main_team'] == 'team_A'
      }
    }, [_vm._v(_vm._s(match['team_A_name']))]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": match['match_href']
      }
    }, [_c('span', {
      staticClass: "stat"
    }, [_vm._v(_vm._s(match['score']))])])]), _vm._v(" "), _c('td', {
      class: {
        team: match['main_team'] == 'team_B'
      }
    }, [_vm._v(_vm._s(match['team_B_name']))])])
  })], 2)])] : _c('div', {
    staticClass: "none"
  }, [_vm._v(_vm._s(_vm.$t('pg_no')))])], 2) : _vm._e(), _vm._v(" "), (_vm.sideline && _vm.sideline.max) ? [_c('nav', {
    staticClass: "t"
  }, [_vm._v(" " + _vm._s(_vm.$t('absentee')) + " " + _vm._s(_vm.sideline.max))]), _vm._v(" "), _c('article', {
    staticClass: "con"
  }, [_c('table', {
    staticClass: "list_3"
  }, [_c('tbody', [_c('tr', [_c('th', [_c('img', {
    attrs: {
      "src": _vm.getImgSrc(_vm.team_A_logo),
      "alt": ""
    },
    on: {
      "error": _vm.loadDefaultImg
    }
  }), _vm._v(" " + _vm._s(_vm.team_A) + "\n                    ")]), _vm._v(" "), _c('th', [_c('img', {
    attrs: {
      "src": _vm.getImgSrc(_vm.team_B_logo),
      "alt": ""
    },
    on: {
      "error": _vm.loadDefaultImg
    }
  }), _vm._v(" " + _vm._s(_vm.team_B) + "\n                    ")])]), _vm._v(" "), _vm._l((_vm.sideline.max), function(i) {
    return _c('tr', {
      key: i
    }, [_c('td', [(_vm.sideline['team_A'][i - 1]) ? [_c('span', {
      staticClass: "num"
    }, [_vm._v(" " + _vm._s(_vm.sideline['team_A'][i - 1]['shirtnumber']))]), _vm._v(" "), _c('a', {
      attrs: {
        "href": _vm.sideline['team_A'][i - 1]['href']
      }
    }, [_vm._v(_vm._s(_vm.sideline['team_A'][i - 1]['name']) + " ")]), _vm._v(" "), _c('span', {
      class: 'reason ' + _vm.sideline['team_A'][i - 1]['reason']
    }, [_vm._v(" " + _vm._s(_vm.sideline['team_A'][i - 1]['reason_char']) + " ")])] : _vm._e()], 2), _vm._v(" "), _c('td', [(_vm.sideline['team_B'][i - 1]) ? [_c('span', {
      staticClass: "num"
    }, [_vm._v(" " + _vm._s(_vm.sideline['team_B'][i - 1]['shirtnumber']))]), _vm._v(" "), _c('a', {
      attrs: {
        "href": _vm.sideline['team_B'][i - 1]['href']
      }
    }, [_vm._v(_vm._s(_vm.sideline['team_B'][i - 1]['name']) + " ")]), _vm._v(" "), _c('span', {
      class: 'reason ' + _vm.sideline['team_B'][i - 1]['reason']
    }, [_vm._v(" " + _vm._s(_vm.sideline['team_B'][i - 1]['reason_char']) + " ")])] : _vm._e()], 2)])
  })], 2)])])] : _vm._e(), _vm._v(" "), (_vm.league_table) ? [_c('nav', {
    staticClass: "t"
  }, [_vm._v(_vm._s(_vm.$t('league_table')))]), _vm._v(" "), _c('article', {
    staticClass: "con"
  }, [_vm._l((_vm.league_table), function(tables, team) {
    return (team !== 'name') ? [_c('div', {
      key: team,
      staticClass: "title"
    }, [_c('img', {
      attrs: {
        "src": team === 'team_A' ? _vm.getImgSrc(_vm.team_A_logo) : _vm.getImgSrc(_vm.team_B_logo),
        "alt": ""
      },
      on: {
        "error": _vm.loadDefaultImg
      }
    }), _vm._v(" " + _vm._s(team === 'team_A' ? _vm.team_A : _vm.team_B) + "\n                ")]), _vm._v(" "), _c('table', {
      key: tables.name
    }, [_c('tbody', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('lt_format')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('lt_p')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('lt_w')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('lt_d')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('lt_l')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('lt_f')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('lt_a')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('lt_pts')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('lt_rank')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('lt_wp')))])]), _vm._v(" "), _vm._l((tables), function(table, tabletype) {
      return _c('tr', {
        key: table.name
      }, [_c('td', [_vm._v(_vm._s(_vm.$t('lt_' + table['name'])))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(table['matches_total']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(table['matches_won']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(table['matches_draw']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(table['matches_lost']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(table['goals_pro']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(table['goals_against']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(table['points']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(table['rank']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(table['win_rate']))])])
    })], 2)])] : _vm._e()
  })], 2)] : _vm._e(), _vm._v(" "), (_vm.cup_table) ? [_c('nav', [_vm._v(_vm._s(_vm.cup_table['name']))]), _vm._v(" "), _c('article', {
    staticClass: "con"
  }, [_c('table', {
    staticClass: "list_2"
  }, [_c('tbody', [_c('tr', [_c('th', {
    staticClass: "rank"
  }), _vm._v(" "), _c('th', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$t('ct_team')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('ct_p')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('ct_w')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('ct_d')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('ct_l')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('ct_fa')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('ct_pts')))])]), _vm._v(" "), _vm._l((_vm.cup_table.list), function(team, rank) {
    return _c('tr', {
      key: rank,
      class: {
        top: team.color == 'green'
      }
    }, [_c('td', [_vm._v(_vm._s(team['rank']))]), _vm._v(" "), _c('td', {
      staticClass: "name"
    }, [_c('img', {
      attrs: {
        "src": _vm.getImgSrc(team['logo']),
        "alt": ""
      },
      on: {
        "error": _vm.loadDefaultImg
      }
    }), _vm._v(" " + _vm._s(team['name']) + "\n                    ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(team['matches_total']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(team['matches_won']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(team['matches_draw']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(team['matches_lost']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(team['goals_pro']) + "/" + _vm._s(team['goals_against']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(team['points']))])])
  })], 2)])])] : _vm._e(), _vm._v(" "), _c('nav', {
    attrs: {
      "id": "odd"
    }
  }, [_vm._v(_vm._s(_vm.$t('odds')) + "\n        ")]), _vm._v(" "), (_vm.has_odds) ? _c('article', {
    staticClass: "con",
    attrs: {
      "id": "odd_list"
    }
  }, [_c('div', {
    staticClass: "title_1"
  }, [_vm._v(_vm._s(_vm.$t('odds_handicap')))]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "tab://4"
    }
  }, [_c('table', {
    staticClass: "list_4"
  }, [_c('tbody', [_c('tr', [_c('th', {
    staticClass: "company"
  }, [_vm._v(_vm._s(_vm.$t('odds_company')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('odds_type')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('odds_home_lose')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('odds_hdp')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('odds_away_lose')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('odds_tu')))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "title_1"
  }, [_vm._v(_vm._s(_vm.$t('odds_1x2')))]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "tab://4"
    }
  }, [_c('table', {
    staticClass: "list_4"
  }, [_c('tbody', [_c('tr', [_c('th', {
    staticClass: "company"
  }, [_vm._v(_vm._s(_vm.$t('odds_company')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('odds_type')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('odds_home_win')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('odds_draw')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('odds_away_win')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('odds_tu')))])]), _vm._v(" "), (_vm.aver) ? _c('tr', [_c('td', {
    staticClass: "company"
  }, [_vm._v(_vm._s(_vm.$t('odds_average')))]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "red"
  }, [_vm._v(_vm._s(_vm.$t('odds_spot')))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Boolean(_vm.aver['now']['homeWin']) ? _vm.aver['now']['homeWin'] : '---'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Boolean(_vm.aver['now']['draw']) ? _vm.aver['now']['draw'] : '---'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Boolean(_vm.aver['now']['awayWin']) ? _vm.aver['now']['awayWin'] : '---'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Boolean(_vm.aver['now']['ts']) ? _vm.aver['now']['ts'] : '---'))])]) : _vm._e()])])])]) : _c('div', {
    staticClass: "none"
  }, [_vm._v(_vm._s(_vm.$t('odds_no')))]), _vm._v(" "), _c('nav', [_vm._v(_vm._s(_vm.$t('recent_games')))]), _vm._v(" "), _vm._l((_vm.recent_record), function(matches, team) {
    return (team !== 'name') ? _c('article', {
      key: team,
      staticClass: "con"
    }, [_c('div', {
      staticClass: "title t"
    }, [_c('img', {
      attrs: {
        "src": team === 'team_A' ? _vm.getImgSrc(_vm.team_A_logo) : _vm.getImgSrc(_vm.team_B_logo),
        "alt": ""
      },
      on: {
        "error": _vm.loadDefaultImg
      }
    }), _vm._v(" " + _vm._s(team ===
      'team_A' ? _vm.team_A : _vm.team_B) + "\n        ")]), _vm._v(" "), (matches && matches.length) ? _c('table', {
      staticClass: "list_1"
    }, [_c('tbody', [_c('tr', [_c('th', {
      staticClass: "date"
    }, [_vm._v(_vm._s(_vm.$t('rg_date')))]), _vm._v(" "), _c('th', {
      staticClass: "cup"
    }, [_vm._v(_vm._s(_vm.$t('rg_competition')))]), _vm._v(" "), _c('th', {
      staticClass: "home"
    }, [_vm._v(_vm._s(_vm.$t('rg_home')))]), _vm._v(" "), _c('th', {
      staticClass: "stat"
    }, [_vm._v(_vm._s(_vm.$t('rg_result')))]), _vm._v(" "), _c('th', {
      staticClass: "away"
    }, [_vm._v(_vm._s(_vm.$t('rg_away')))])]), _vm._v(" "), _vm._l((matches), function(match, id) {
      return _c('tr', {
        key: id,
        class: match['color']
      }, [_c('td', {
        staticClass: "time"
      }, [_c('p', [_vm._v(_vm._s(match['date']))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(match['year']))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(match['competition']))]), _vm._v(" "), _c('td', {
        class: {
          team: match['main_team'] === 'team_A'
        }
      }, [_vm._v(_vm._s(match['team_A_name']))]), _vm._v(" "), _c('td', [_c('a', {
        attrs: {
          "href": match['match_href']
        }
      }, [_c('span', {
        staticClass: "stat"
      }, [_vm._v(_vm._s(match['score']))])])]), _vm._v(" "), _c('td', {
        class: {
          team: match['main_team'] === 'team_B'
        }
      }, [_vm._v(_vm._s(match['team_B_name']))])])
    })], 2)]) : _c('div', {
      staticClass: "none"
    }, [_vm._v(_vm._s(_vm.$t('rg_no')))])]) : _vm._e()
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1fd95a5a","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pastGames.vue
// module id = 667
// module chunks = 2